import React from 'react';
import SearchBoxContainer from '../../components/searchBoxContainer/SearchBoxContainer';
import HomePageHeader from './HomePageHeader';
import Analytics from '../../components/modules/tudo-azul-analytics';
import RefreshTokenCallcenterProvider from '../../components/providers/refreshTokenCallcenter/RefreshTokenCallcenterProvider';
import * as LoggedUserCallcenterUC from '../../usecases/loggedUserCallcenter/LoggedUserCallcenterUC';
import './HomePages.css';
import { withCookies, Cookies } from 'react-cookie';
import Cookie from '../../const/Cookie';
import PropTypes from 'prop-types';
import SearchPNRFormContainer from '../../components/searchPNRFormContainer/SearchPNRFormContainer';

const propTypes = {
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  location: PropTypes.object,
  history: PropTypes.object
};

class HomePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      typeTrip: 'roundTrip',
      flightOrigin: null,
      flightDestiny: null,
      startDate: null,
      endDate: null,
      totalAdults: Number(1),
      totalKids: Number(0),
      totalBabys: Number(0),
      cabinCategory: 'ECONOMY',
      typeOfFlight: null,
      companiesIdentity: '',
      selectedTab: 'search',
      isCallcenterMode: null
    };

    this.loadFilter = this.loadFilter.bind(this);
  }

  componentWillMount() {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.flightsFilter
    ) {
      const filter = this.props.location.state.flightsFilter;
      this.loadFilter(filter);
      LoggedUserCallcenterUC.execute(this.props.location.state.keepLoggedUser);
    } else {
      LoggedUserCallcenterUC.execute();
    }

    this.logout(Cookie.USER_DATA_CALLCENTER);

    if (this.props.history) {
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: this.props.location.search,
        state: {}
      });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    Analytics.trackingSearch();
  }

  loadFilter(filter) {
    this.setState({
      typeTrip: filter.typeTrip,
      flightOrigin: filter.flightOrigin,
      flightDestiny: filter.flightDestiny,
      startDate: filter.startDate,
      endDate: filter.endDate,
      totalAdults: filter.totalAdults,
      totalKids: filter.totalKids,
      totalBabys: filter.totalBabys,
      cabinCategory: filter.cabinCategory,
      typeOfFlight: filter.typeOfFlight,
      companiesIdentity: filter.companiesIdentity
    });
  }

  logout = loginDataCookie => {
    this.props.cookies.remove(loginDataCookie);
  };

  setSelectedTab = tab => {
    this.setState({
      selectedTab: tab
    });
  };

  callbackCallcenterMode = isCallcenterMode => {    
    this.setState({
      isCallcenterMode: isCallcenterMode
    });
  }; 

  render() {    
    return (
      <div>
        <RefreshTokenCallcenterProvider />
        <HomePageHeader selectedTab={this.state.selectedTab} setSelectedTab={this.setSelectedTab} isCallcenterMode={this.state.isCallcenterMode} />
        <div id="pageHome">
          <section className="container-fluid section__outer pad-bot-5">
            {this.state.selectedTab === 'login' ? (
              <SearchPNRFormContainer location={this.props.location} />
            ) : (
              <SearchBoxContainer
                {...this.state}
                location={this.props.location}
                loadRecentFlight={this.loadFilter}
                callbackCallcenterMode={this.callbackCallcenterMode}
              />
            )}
          </section>
        </div>
      </div>
    );
  }
}

HomePage.propTypes = propTypes;

export default withCookies(HomePage);



// WEBPACK FOOTER //
// ./src/page/home/HomePage.jsx